module.exports = __webpack_public_path__ + "media/ToneNotification0.78143069.mp3";